var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsappColor = function SvgWhatsappColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.004,
    y: 0.064,
    fill: "#48C95F",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#whatsapp-color_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.433,
    y: 1.492,
    fill: "#48C95F",
    rx: 2.857
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.005,
    cy: 10.064,
    r: 8.214,
    fill: "#48C95F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.571 6.493a4.62 4.62 0 0 0-3.276-1.357 4.63 4.63 0 0 0-4.639 4.622c0 .808.228 1.616.617 2.295l-.649 2.392 2.465-.646c.681.355 1.428.549 2.206.549a4.63 4.63 0 0 0 4.639-4.622c-.033-1.196-.487-2.36-1.363-3.233m-1.038 4.913c-.097.26-.551.518-.778.55a1.8 1.8 0 0 1-.714-.032c-.162-.065-.39-.13-.649-.259-1.167-.485-1.913-1.648-1.978-1.745-.065-.065-.487-.615-.487-1.196 0-.582.292-.84.39-.97.097-.13.226-.13.324-.13h.227c.065 0 .162-.032.26.194.097.227.324.809.356.84a.2.2 0 0 1 0 .195.7.7 0 0 1-.13.194c-.065.064-.13.161-.162.194-.065.064-.13.129-.065.226.065.13.292.485.649.808.454.388.81.517.94.582s.195.032.26-.032c.065-.065.292-.324.357-.453.065-.13.162-.097.26-.065a9 9 0 0 1 .778.388c.13.065.195.097.227.13.032.097.032.323-.065.582"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "whatsapp-color_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.433 1.492h17.143v17.143H1.433z"
  })))));
};
export default SvgWhatsappColor;